export default "__VITE_ASSET__B_xY_so9__"